import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { useCallback, useEffect, useState } from "react";
import {
  localStorageGetHasInteractedWithFssDashChat,
  localStorageSetHasInteractedWithFssDashChat,
} from "../utils/localStorageUtils";

export const useFssDashChatUserInteraction = (
  isEmbed: boolean,
  conversationId: string | undefined,
) => {
  const [hasUsedFssDashChat, setHasUsedFssDashChat] = useState(false);
  const isWeb = EnvCtx.surface === "web";
  const isValidFssDashChat = isEmbed && isWeb;

  useEffect(() => {
    if (!isValidFssDashChat || !conversationId) {
      // We only want to track interactions in the iframe within the FSS Dash Chat
      return;
    }

    const hasInteractedWithFssDashChat =
      localStorageGetHasInteractedWithFssDashChat();
    setHasUsedFssDashChat(hasInteractedWithFssDashChat);
  }, [isValidFssDashChat, conversationId]);

  const handleFssDashChatUserInteraction = useCallback(() => {
    if (!isValidFssDashChat || hasUsedFssDashChat) {
      // We only want to track interactions in the iframe within the FSS Dash Chat.
      // If that interaction has already been recorded, we do not need to update localStorage again.
      return;
    }

    // We don't call setHasUsedFssDashChat here because we want to avoid having the header change while query is running
    localStorageSetHasInteractedWithFssDashChat();
  }, [isValidFssDashChat, hasUsedFssDashChat]);

  return {
    hasUsedFssDashChat,
    handleFssDashChatUserInteraction,
  };
};
